import { render } from "./FormattedTimestamp.vue?vue&type=template&id=74b268be"
import script from "./FormattedTimestamp.vue?vue&type=script&lang=js"
export * from "./FormattedTimestamp.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__